import { RequestPolicy, RequestPolicyFactory, RequestPolicyOptionsLike } from '@azure/core-http';

import { AntiforgeryTokenPolicy, IAntiforgeryTokenPolicyOptions } from './AntiforgeryTokenPolicy';

export class AntiforgeryTokenPolicyFactory implements RequestPolicyFactory {
  private antiforgeryOptions: IAntiforgeryTokenPolicyOptions;

  constructor(antiforgeryOptions: IAntiforgeryTokenPolicyOptions) {
    this.antiforgeryOptions = antiforgeryOptions;
  }

  create(nextPolicy: RequestPolicy, options: RequestPolicyOptionsLike): RequestPolicy {
    return new AntiforgeryTokenPolicy(nextPolicy, options, this.antiforgeryOptions);
  }
}
